import { useState } from "react";
import "./Addproperties.css";
import UploadWidget from "../../Components/uploadWidget/UploadWidget";
import { useNavigate } from "react-router-dom";
import axios from "axios";
//import Value from "./Value";

function Addproperties() {
  const [value, setValue] = useState("");
  const [images, setImages] = useState([]);
  const [error, setError] = useState("");

  const navigate = useNavigate()

  const handleSubmit = async (e) => {
  e.preventDefault();    
    const formData = new FormData(e.target);
    const inputs = Object.fromEntries(formData);

   try {
      const res = await axios.post("http://104.214.177.15:8080/api/Property/GetProperties", {
        postData: {
          title: inputs.title,
          price: parseInt(inputs.price),
          address: inputs.address,
          city: inputs.city,
          bathroomNumber: parseInt(inputs.bathroomNumber),
          bedroomNumber: parseInt(inputs.bedroomNumber),
          licenseNumber: parseInt(inputs.licenseNumber),
          propertyCode: parseInt(inputs.propertyCode),
          type: inputs.type,
          propertyType: inputs.propertyType,
          image: images,
        },
        postDetail: {
          description: value,
          utilitiesPolicy: inputs.utilities,
          petPolicy: inputs.pet,
          incomePolicy: inputs.income,
          size: parseInt(inputs.size),
          school: parseInt(inputs.school),
        },
      });
      navigate("/singlepageproperty"+res.data.id)
    } catch (err) {
      console.log(err);
      setError(error);
    }
  };
 
    


  return (
    <div className="newPostPage">
      <div className="formContainer">
        <h1>Add New Post</h1>
        <div className="wrapper">
          <form onSubmit={handleSubmit}>
            <div className="item">
              <label htmlFor="title">Title</label>
              <input id="title" name="title" type="text" />
            </div>
            <div className="item">
              <label htmlFor="price">Price</label>
              <input id="price" name="price" type="number" />
            </div>
            <div className="item">
              <label htmlFor="address">Address</label>
              <input id="address" name="address" type="text" />
            </div>
           
            <div className="item">
              <label htmlFor="city">City</label>
              <input id="city" name="city" type="text" />
            </div>
            <div className="item">
              <label htmlFor="bedroom">Bedroom Number</label>
              <input min={1} id="bedroom" name="bedroomNumber" type="number" />
            </div>
            <div className="item">
              <label htmlFor="bathroom">Bathroom Number</label>
              <input min={1} id="bathroom" name="bathroomNumber" type="number" />
            </div>
            <div className="item">
              <label htmlFor="license">License number</label>
              <input id="license" name="licenseNumber" type="text" />
            </div>
            <div className="item">
              <label htmlFor="pcode">Property Code</label>
              <input id="pcode" name="propertyCode" type="text" />
            </div>
            <div className="item">
              <label htmlFor="type">Type</label>
              <select name="type">
                <option value="rent" defaultChecked>
                  Rent
                </option>
                <option value="sale">sale</option>
              </select>
            </div>
            <div className="item">
              <label htmlFor="type">Property</label>
              <select name="propertyType">
                <option value="apartment">Apartment</option>
                <option value="house">House</option>
                <option value="villa">Villa</option>
                <option value="land">Land</option>
              </select>
            </div>

            <div className="item">
              <label htmlFor="utilities">Utilities Policy</label>
              <select name="utilitiesPolicy">
                <option value="owner">Owner is responsible</option>
                <option value="tenant">Tenant is responsible</option>
                <option value="shared">Shared</option>
              </select>
            </div>
            <div className="item">
              <label htmlFor="pet">Pet Policy</label>
              <select name="petPolicy">
                <option value="allowed">Allowed</option>
                <option value="not-allowed">Not Allowed</option>
              </select>
            </div>
            <div className="item">
              <label htmlFor="income">Income Policy</label>
              <input
                id="income"
                name="incomePolicy"
                type="text"
                placeholder="Income Policy"
              />
            </div>
            <div className="item">
              <label htmlFor="size">Total Size (sqft)</label>
              <input min={0} id="size" name="size" type="number" />
            </div>
            <div className="item">
              <label htmlFor="school">School</label>
              <input min={0} id="school" name="school" type="number" />
            </div>
            
            <div className="item description">
  <label htmlFor="desc">Description</label>
  <textarea 
    id="desc" 
    className="description-textarea"
    value={value} 
    onChange={(e) => setValue(e.target.value)} 
    rows="4"
    placeholder="Enter description here..."
  />
</div>


           
            <button className="sendButton" type="submit">Add</button>
            {error && <span>error</span>}
          </form>
        </div>
      </div>
      <div className="sideContainer">
        {Array.isArray(images) ?images.map((image, index) => (
            <img src={image} key={index} alt='' />
        )):<p>No images available</p>}
        <UploadWidget
          uwConfig={{
            multiple: true,
            cloudName: "akari",
            uploadPreset: "estate",
            folder: "posts",
          }}
          setState={setImages}
        />
        
        
      </div>
    </div> 
    
  );
}

export default Addproperties;

